import DeviceLinking from "./components/device-linking/device-linking";
import {useEffect, useMemo, useRef, useState} from "react";
import {fetchTrendingMovies} from "../../cap17drive/api/cap17drive-api";
import {useBackground} from "../body/backgroundContext/backgroundContext";
import {getTmdbImage} from "../../../utils/consts";
import SocketUtils, {randomBytes, useSocketEvents} from "./socket-utils/socketUtils";
import {Spinner} from "../../shared";
import {setDarkMode} from "../../../utils/utils";
import {setDarkModeAction} from "../../users/actions";
import {useDispatch} from "react-redux";
import SquadflixTv from "./components/squadflix-tv/squadflix-tv";
import SquadflixTvPlayer from "./components/squadflix-tv-player/squadflix-tv-player";

const SquadflixTvMode = () => {

    const {setBackground} = useBackground();
    const dispatch = useDispatch();
    const [deviceInfo, setDeviceInfo] = useState(JSON.parse(localStorage.getItem("squadflixtv-deviceInfo")));
    const [connected, setConnected] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const [video, setVideo] = useState();
    const item = useRef();

    const mainItem = useMemo(() => selectedItem?.serie ?? selectedItem, [selectedItem]);

    const events = useMemo(() => ({
        viewing_item: (data) => {
            console.log("Viewing item event received:", data);
            setSelectedItem(data?.item ?? undefined);
        },
        play_video_squadflix: (data) => {
            setVideo(data.video);
            console.log("Play video event received:", data);
        }
    }), [setSelectedItem]);
    useSocketEvents({connected, events});
    // device type: {deviceId, name, type, location, linkedAt, uid}
    const [deviceId, setDeviceId] = useState(localStorage.getItem("squadflixtv-deviceId"));

    useEffect(() => {
        item.current = selectedItem;
        console.log("Selected item changed:", selectedItem);
    }, [selectedItem, setBackground]);

    useEffect(() => {
        if (!mainItem) return;

        const imagePath = mainItem?.backdrop_path ?? mainItem?.poster_path;
        const imageUrl = getTmdbImage(imagePath, 'original');

        setBackground(`url(${imageUrl}) center center / cover no-repeat`);
    }, [mainItem, setBackground]);

    useEffect(() => {
        let dev = localStorage.getItem("squadflixtv-deviceId");
        if (!dev) {
            dev = randomBytes(32);
            localStorage.setItem("squadflixtv-deviceId", dev);
        }
        setDeviceId(dev);
    }, [deviceId, setDeviceId]);


    useEffect(() => {
        if (!deviceId) return;

        setDarkMode(true);
        dispatch(setDarkModeAction(true));

        // send auth headers
        const connectSocket = async () => {
            SocketUtils.connect({deviceId, uid: deviceInfo?.uid}).then(() => {
                setConnected(true);
            });
        }

        connectSocket();

        return () => {
            SocketUtils.disconnect();
            setConnected(false);
        }
    }, [deviceId, dispatch, deviceInfo]);

    useEffect(() => {
        let changeBackgroundInterval = null;

        const backgroundPosterSlide = async () => {
            const trendingMovies = (await fetchTrendingMovies()).results;
            if (!trendingMovies || trendingMovies.length === 0) {
                console.error("No trending movies found.");
                return;
            }

            const handleSetRandomBackground = async () => {
                const randomIndex = Math.floor(Math.random() * trendingMovies.length);
                const selectedMovie = trendingMovies[randomIndex];
                if (selectedMovie && (selectedMovie.backdrop_path || selectedMovie.poster_path)) {
                    const imageUrl = getTmdbImage(selectedMovie.backdrop_path ?? selectedMovie.poster_path, 'original');
                    const imageFetched = await fetch(imageUrl);
                    if (!imageFetched.ok) {
                        console.error("Failed to fetch image from URL:", imageUrl);
                        return;
                    }
                    const image = await imageFetched.blob();
                    setBackground(`url(${URL.createObjectURL(image)}) center center / cover no-repeat`);
                } else {
                    console.error("Selected movie does not have a backdrop path.");
                }
            }

            handleSetRandomBackground();

            changeBackgroundInterval = setInterval(() => {
                if (item.current) return;
                handleSetRandomBackground();
            }, 20000); // Cambia de fondo cada 20 segundos
        }

        backgroundPosterSlide().catch((error) => {
            console.error("Error fetching trending movies:", error);
        });

        return () => {
            if (changeBackgroundInterval) {
                clearInterval(changeBackgroundInterval);
            }
        }
    }, []);

    const handleClearDeviceInfo = () => {
        setDeviceInfo(null)
        localStorage.removeItem(`squadflixtv-deviceInfo`)
    }

    if (!connected) {
        return <div className="d-flex justify-content-center align-items-center vh-100">
            <Spinner/>
        </div>
    }

    if (!deviceInfo) {
        return <DeviceLinking setDeviceInfo={setDeviceInfo} deviceId={deviceId}/>
    }

    if (video) {
        return <SquadflixTvPlayer video={video} deviceInfo={deviceInfo} connected={connected}/>
    }

    return <SquadflixTv onDeletedDevice={handleClearDeviceInfo} device={deviceInfo} selectedItem={selectedItem}
                        mainItem={mainItem}/>
}

export default SquadflixTvMode;
